<div class="product-wrapper fx-layout-column fx-align--space-between-x" *ngIf="product" [ngClass]="{inactive: !product.active}">
  <div class="inactive-message">
    Temporarily<br />Out of Stock
  </div>
  <div>
    <div [ngClass]="{'landscape': thumbOrientation === 'landscape'}" class="square-container"
         [ngStyle]="{'background-image': product.thumbPreviewBackground ? 'url(' + product.thumbPreviewBackground + ')' : null}">
      <div class="image-wrapper" [ngClass]="{'show-kit': product.project?.primaryProduct === 'SHOW-KIT' && product.thumbPreviewStyle == 'GENERATED'}">
        <img loading="lazy"
             [src]="product.image?.src"
             (click)="showThumbOrRedirect(product.image?.largeImageSrc)"
             [matTooltip]="toolTip(product.image?.src)"
             [ngClass]="{shadow: product.image?.shadow}"
             [alt]="product.name"
        />
      </div>

      <div class="selections-wrapper">
        <table *ngIf="product.project && !product.fixedProject && !projectIsPreview">
          <tbody>
            <tr>
              <td>
                <strong>{{ product.project.size }}</strong>
                <ng-container *ngIf="product.project.numOpenings == 1">
                  /w <strong>{{ product.project.opening.size }}</strong> Opening
                </ng-container>

                <button mat-mini-fab color="secondary" (click)="chooseSize()">
                  <mat-icon svgIcon="pencil" class="sm"></mat-icon>
                </button>
              </td>
            </tr>
          <!--
          <tr *ngIf="product.project.backingBoard && product.project.backingBoard.description">
            <th>Backing:</th>
            <td>{{ product.project.backingBoard.description }}</td>
          </tr>
          <tr *ngIf="product.project.bag">
            <th>Clear Bag:</th>
            <td>Yes</td>
          </tr>
          -->
          </tbody>
        </table>

        @for (prop of ['moulding','topMat','bottomMat','backingBoard','glazing']; track prop) {
          <table *ngIf="product.project && !projectIsPreview && product.project[productCategories[prop].projectProperty] && multiOption(product.projectData[productCategories[prop].projectDataProperty])">
            <tbody>
              <tr>
                <th>{{ productCategories[prop].titleAfterChosen ? productCategories[prop].titleAfterChosen : productCategories[prop].title }}:</th>
                <td>
                  {{ product.project[productCategories[prop].projectProperty].description }}
                  <button mat-mini-fab color="secondary" *ngIf="!product.fixedProject" (click)="openSelectorDialog(productCategories[prop])">
                    <mat-icon svgIcon="pencil" class="sm"></mat-icon>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        }
      </div>
    </div>

    <h3>
      <ng-container *ngIf="product.packSize > 1">({{product.packSize}})</ng-container>
      <span [innerHtml]="product.name"></span>
    </h3>

    <span *ngIf="product.description" [innerHtml]="product.description"></span>
  </div>

  <div class="bottom-section xfx-layout-column xfx-align--end-x xfx-align--x-center">
    <mbnm-shop-detail-buy-section
      *ngIf="product.project && !projectIsPreview"
      [product]="product">
    </mbnm-shop-detail-buy-section>

    @if (projectIsPreview && product.project && product.project.minPrice !== product.project.maxPrice) {
      <span class="price" *ngIf="product.project.price > product.project.minPrice">
        from <b>{{ product.project.minPrice | currency }}</b>
        <div>for 1000+</div>
      </span>

      <span class="price" *ngIf="product.project.qty === 1 && product.project.price !== product.project.maxPrice">
        <s>{{ product.project.maxPrice | currency }}</s>
        <b>{{ product.project.price | currency }}</b>
      </span>
    }

    <!-- primary action button -->
    <button mat-flat-button color="primary" (click)="primaryButtonClicked($event)" *ngIf="product.builderButton.link !== 'NONE'">
      <ng-container *ngIf="product.sizeSelector !== 'NONE' && projectIsPreview">{{ product.builderButton.chooseOptionsText}}</ng-container>
      <ng-container *ngIf="product.sizeSelector == 'NONE' || (product.project && !projectIsPreview)">{{ product.builderButton.text }}</ng-container>
    </button>
  </div>
</div>
